"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["children", "className", "variant", "size", "block", "tag", "type"];
var variantClasses = {
  primary: 'btn_primary',
  light: 'btn_light',
  'primary-outline': 'btn_primary-outline',
  'secondary-outline': 'btn_secondary-outline',
  'light-outline': 'btn_light-outline',
  'danger-outline': 'btn_danger-outline',
  link: 'btn_link'
};
var sizeClasses = {
  sm: 'btn_sm',
  md: '',
  // default size has no special class
  lg: 'btn_lg'
};
var Button = exports.Button = function Button(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$block = _ref.block,
    block = _ref$block === void 0 ? false : _ref$block,
    Tag = _ref.tag,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    elementProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _elementProps$disable = elementProps.disabled,
    disabled = _elementProps$disable === void 0 ? false : _elementProps$disable,
    href = elementProps.href;
  var elementClasses = (0, _classnames["default"])('btn', variantClasses[variant], sizeClasses[size], className, {
    'btn_block': block,
    disabled: href && disabled && !Tag
  });
  if (Tag) {
    return /*#__PURE__*/_react["default"].createElement(Tag, (0, _extends2["default"])({}, elementProps, {
      className: elementClasses
    }), children);
  }
  var BtnComponent = href ? 'a' : 'button';
  var btnType = !href ? type : undefined;
  return /*#__PURE__*/_react["default"].createElement(BtnComponent, (0, _extends2["default"])({}, elementProps, {
    type: btnType,
    disabled: disabled && !href,
    className: elementClasses
  }), children);
};

// is only needed to avoid snapshots updating
Button.defaultProps = {
  variant: 'primary',
  className: null,
  block: false,
  size: 'md',
  type: 'button',
  href: null,
  disabled: false,
  tag: null
};